import { Component, Input, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagemImovelDto, ImovelResponseDto } from '../../dto/imovel-response.dto';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { Router } from '@angular/router';

@Component({
   selector: 'app-swiper-imagens',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './swiper-imagens.component.html',
   styleUrls: ['./swiper-imagens.component.scss'],
   schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class SwiperImagensComponent {
   @Input() imagens: ImagemImovelDto[] = [];
   @Input() imovelSlug: string | null = null;
   @Input() imovel: ImovelResponseDto;

   constructor(
      private router: Router
   ) { }
   ngOnInit() {
      //limitar imagens a 8
      if (this.imagens.length > 8) {
         this.imagens = this.imagens.slice(0, 8);
      }
   }
   abreImovel(): void {
      if (!this.imovelSlug) {
         console.error('ID do imóvel não fornecido');
         return;
      }
      // Navega para a rota do imóvel com o ID fornecido
      const url = this.router.serializeUrl(this.router.createUrlTree(['/imovel', this.imovelSlug]));
      window.open(url, '_blank'); // Abre em uma nova aba
   }

   hasFeirao() {
         return this.imovel && this.imovel.tags && this.imovel.tags.includes('feirao');
   }

}
